/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type { InputDescription } from "@smartsuite/automation-engine-api";
import { Text } from "@smartsuite/react-ui/lib";
import { observer } from "mobx-react-lite";
import { CaptionBlock } from "../../../../../../../../components/CaptionBlock";
import { StyledContainerWrapper } from "../../../style";
import {
  StyledUrlReadOnlyCopyBtn,
  StyledUrlReadOnlyInput,
  StyledUrlReadOnlySection,
  StyledUrlReadOnlyWrapper,
} from "./style";
import type { InputCandidate } from "../../../../../../../../types/candidate";
import { useEffect, useState } from "react";
import { translateIfPresent } from "../../../../../../../../locales/i18n";

export const UrlReadOnlyEditor = observer<{
  input: InputCandidate;
  onChange: (input: InputCandidate) => void;
  onClickTrash?: () => void;
  description?: InputDescription;
}>(({ input, onChange, description, onClickTrash }) => {
  const [value, setValue] = useState<string | undefined>(undefined);
  const [copyBtnLabel, setCopyBtnLabel] = useState<string | undefined>(
    undefined,
  );
  const [isOnClick, setIsOnClick] = useState<boolean>(false);

  useEffect(() => {
    if (isOnClick && value) {
      void navigator.clipboard.writeText(value);
      const resetOnClickId = setTimeout(() => {
        setIsOnClick(false);
      }, 3000);
      return () => clearTimeout(resetOnClickId);
    }
  }, [isOnClick]);

  useEffect(() => {
    if (description?.editor?.editor.oneofKind === "urlReadOnly") {
      setValue(description?.editor.editor.urlReadOnly.url);
      setCopyBtnLabel(description?.editor.editor.urlReadOnly.copyButtonLabel);
    }
  }, [description]);

  useEffect(() => {
    if (value !== undefined) {
      onChange({
        ...input,
        value: {
          values: [
            {
              value: {
                oneofKind: "string",
                string: value,
              },
            },
          ],
        },
      });
    }
  }, [value]);

  const onClick = (): void => {
    setIsOnClick(true);
  };

  return (
    <StyledContainerWrapper>
      {description !== undefined && (
        <CaptionBlock description={description} onClickTrash={onClickTrash} />
      )}
      <StyledUrlReadOnlyWrapper>
        <StyledUrlReadOnlySection>
          <StyledUrlReadOnlyInput
            readOnly
            value={value ?? ""}
            onBlur={(e) => {
              e.currentTarget.scrollLeft = 0;
            }}
            title={value}
            aria-label={description?.label}
          />
        </StyledUrlReadOnlySection>
        <StyledUrlReadOnlyCopyBtn onClick={() => onClick()}>
          <Text>
            {isOnClick
              ? translateIfPresent(`readonly-editor.Copied`, "Copied")
              : translateIfPresent(
                  `readonly-editor.${copyBtnLabel ?? "Copy"}`,
                  copyBtnLabel ?? "Copy",
                )}
          </Text>
        </StyledUrlReadOnlyCopyBtn>
      </StyledUrlReadOnlyWrapper>
    </StyledContainerWrapper>
  );
});
